






























import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';

import {IIdentityUserService} from '@/services/identity/IIdentityUserService';
import {IAuthService} from '@/services/IAuth.service';
import {AuthStore} from '@/store/Auth.store';
import SystemPassword from '@/components/System/SystemPassword.vue';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {SystemPassword},
})
export default class UserSettingsPage extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('IIdentityUserService'))
  private userService!: IIdentityUserService;

  @Inject(Symbol.for('IAuthService'))
  private authService!: IAuthService;

  @Inject(Symbol.for('AuthStore'))
  private authStore!: AuthStore;

  private passwordCurrent: string = '';

  private passwordNew: string = '';

  private formValid: boolean = false;

  private savingPassword: boolean = false;


  private async savePassword(currentPassword: string, newPassword: string) {

    this.savingPassword = true;

    try {
      this.logger.trace('Changing password...');
      await this.userService.setPassword(this.authStore.LoggedUsername, currentPassword, newPassword);
      Notify.Success(this.logger, `The password has been changed`);
    } catch (error) {
      Notify.Error(this.logger, `Could not change password`, error);
    } finally {
      this.savingPassword = false;
    }
  }
}
